import React, {useState} from 'react';

import {SimpleActionButton} from 'components/form/components';

import {IChangeHistoryData, ModalChangeHistory} from './modal-change-history/modal-change-history';

interface IButtonChangeHistoryProps{
    changeHistoryData?: IChangeHistoryData;
}
export const ButtonChangeHistory = ({changeHistoryData}: IButtonChangeHistoryProps) => {
    const [changeHistoryModalVisible, setChangeHistoryModalVisible] = useState(false);

    return (
        <>
            <ModalChangeHistory
                visible={changeHistoryModalVisible}
                changeHistoryData={changeHistoryData}
                onClose={() => setChangeHistoryModalVisible(false)}
            />
            <SimpleActionButton
                type="ghost"
                icon="ClockCircleOutlined"
                title="История изменений"
                onClick={() => setChangeHistoryModalVisible(true)}
            />
        </>
    );
};
